<script>
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  props: {
    showStock: { type: String, default: '' },
    declinaisons: { type: Array, default: function() { return [] } },
    defaultDeclinaison: { type: String, default: '' },
    libUnitPrepa: { type: String, default: '' },
    libUnitTarif: { type: String, default: '' },
    libUnitStock: { type: String, default: '' },
    labelStockOutOfStock: { type: String, default: '' },
    labelStockInStock: { type: String, default: '' },
    labelStockPreOrder: { type: String, default: '' },
    labelStockLimited: { type: String, default: '' },
    labelDimensionLargeur: { type: String, default: '' },
    labelDimensionLongueur: { type: String, default: '' },
    labelDimensionHauteur: { type: String, default: '' }
  },
  data: function () {
    return {
      selected: this.defaultDeclinaison,
      mapLabels: {
        indisponible: this.labelStockOutOfStock,
        enStock: this.labelStockInStock,
        surCommande: this.labelStockPreOrder,
        quantiteLimitee: this.labelStockLimited,
        LARGEUR: this.labelDimensionLargeur,
        LONGUEUR: this.labelDimensionLongueur,
        HAUTEUR: this.labelDimensionHauteur
      }
    }
  },
  computed: {
    currentDeclinaison: function() {
      if( this.selected ) {
        return this.declinaisons.find( ({ HIDDEN_CODE_DECLINAISON }) => HIDDEN_CODE_DECLINAISON === this.selected)
      } else {
        return this.defaultDeclinaison
      }
    }
  },
  methods: {
    getLibelle: function(libelle) {
      return this.mapLabels[libelle]
    },
    interroStockURL: function() {
      if(this.currentDeclinaison.STOCK.INTERRO_STOCK) {
        window.location.href = this.currentDeclinaison.STOCK.INTERRO_STOCK
      }
    }
  }
}
</script>
